import { render, staticRenderFns } from "./AuthorJinNangList.vue?vue&type=template&id=1b5e9684&scoped=true"
import script from "./AuthorJinNangList.vue?vue&type=script&lang=js"
export * from "./AuthorJinNangList.vue?vue&type=script&lang=js"
import style0 from "./AuthorJinNangList.vue?vue&type=style&index=0&id=1b5e9684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e9684",
  null
  
)

export default component.exports